var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 37.2,
  width: 36,
  height: 1.6,
  rx: 0.8,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.5,
  y: 12.5,
  width: 19,
  height: 13.5,
  rx: 1.4,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 14,
  width: 16,
  height: 10.5,
  fill: "#dfe8ee"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 26,
  width: 2.5,
  height: 9.5,
  fill: "#3c4652"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 35.5,
  width: 10.5,
  height: 1.7,
  rx: 0.85,
  fill: "#3c4652"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(8 31 30) translate(-2 1)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 26.5,
  y: 16.5,
  width: 10.5,
  height: 19,
  rx: 1.6,
  fill: "#3c4652"
}), /*#__PURE__*/React.createElement("rect", {
  x: 27.7,
  y: 17.9,
  width: 8.1,
  height: 16.2,
  rx: 0.6,
  fill: "#dfe8ee"
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 33,
  y: 27.5,
  width: 6.2,
  height: 9.7,
  rx: 1.3,
  fill: "#3c4652"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 33.9,
  y: 28.6,
  width: 4.4,
  height: 7.5,
  rx: 0.5,
  fill: "#dfe8ee"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.8,
  cy: 8.8,
  r: 6.6,
  fill: "#23967f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m34 8.8 5.3-3m-5.3 3 5.3 3",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.3,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 8.8,
  r: 1.5,
  fill: "#ffffff"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.3,
  cy: 5.8,
  r: 1.5,
  fill: "#ffffff"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.3,
  cy: 11.8,
  r: 1.5,
  fill: "#ffffff"
});

function SvgSharedTechnology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedTechnology);
export default __webpack_public_path__ + "static/media/shared-technology.2979c2ebe2f5be217215856f7981cc38.svg";
export { ForwardRef as ReactComponent };